import { useEffect } from "react"
import { useNavigate } from "react-router"
import { CONTROL_KITCHEN_ROUTE } from "../../../../constants/routes"
import { Typography } from '@mui/material'
import { LocalizedStrict } from '../../../localization/components/AppLocalized'
import { Player } from "@lottiefiles/react-lottie-player"
import DashboardAnimation from "../assets/animation_ljyatnb9.json"
import { Box } from '@mui/system'
import { Link } from 'react-router-dom'

type MerchantHomeProps = Readonly<{}>

export function MerchantReportsHome({ }: MerchantHomeProps) {
    const navigate = useNavigate()

    // // For now we simply redirect to Purchases page
    // useEffect(() => {
    //     console.info("Navigating to " + CONTROL_KITCHEN_ROUTE)
    //     navigate(CONTROL_KITCHEN_ROUTE)
    // })

    // TODO: Build a proper home page for Merchant
    return (
        <>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <LocalizedStrict id='merchant-home-title' >
                    <Typography variant="h4" gutterBottom sx={{ marginTop: "1.5rem", textAlign: "center" }}>
                        Dashboard sales summary coming soon
                    </Typography>
                </LocalizedStrict>

                <LocalizedStrict id='merchant-home-subtitle'>
                    <Typography variant='body1' gutterBottom>
                        Your sales dashboard will show an overview of important key figures, so you always have a good overview of sales and daily operations.                    </Typography>
                </LocalizedStrict>

                {/* <Typography variant='body1'>
                    Kontakt <Link to="mailto:support@facilitynet.dk">support@facilitynet.dk</Link> for at høre mere...
                </Typography> */}
                <Box sx={{ width: "80%" }}>
                    <Player src={DashboardAnimation} autoplay loop speed={1} />
                </Box>
            </Box>





        </>
    )
}
